import { getMethod, postMethod } from './api-service';

// Fetch vendors by country
export const fetchVendorsByCountry = async (country, productType = "CURTAIN") => {
    try {
        // This endpoint should return vendors filtered by country from vendor.properties.location
        const response = await getMethod(`/raw-material-vendor/list?categorySlug=hardware&country=${country}`);
        return response;
    } catch (error) {
        console.error('Error fetching vendors:', error);
        return { success: false, message: error.message };
    }
};

// Fetch hardware by vendor, type, and product type
export const fetchHardwareByVendorAndType = async (vendorId, hardwareType, productType = "CURTAIN") => {
    try {
        let url = `/raw-material/list?categorySlug=hardware&vendorId=${vendorId}`;
        if (hardwareType) {
            url += `&hardwareType=${hardwareType}`;
        }
        if (productType) {
            url += `&productType=${productType}`;
        }
        const response = await getMethod(url);
        return response;
    } catch (error) {
        console.error('Error fetching hardware:', error);
        return { success: false, message: error.message };
    }
};

// Fetch all hardware options for a product type
export const fetchHardwareOptions = async (productType = "CURTAIN") => {
    try {
        const response = await getMethod(`/raw-material/list?categorySlug=hardware&productType=${productType}`);
        return response;
    } catch (error) {
        console.error('Error fetching hardware options:', error);
        return { success: false, message: error.message };
    }
};

export const fetchCompatibleVendors = async (params) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const response = await getMethod(`/raw-material-vendor/hardware/compatible-vendor?${queryParams}`);
        return response;
    } catch (error) {
        console.error('Error fetching compatible vendors:', error);
        return { success: false, message: error.message, vendors: [] };
    }
};

export const fetchVendorHardware = async (vendorId, params = {}) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const response = await getMethod(`/hardware/vendor/${vendorId}?${queryParams}`);
        return response;
    } catch (error) {
        console.error('Error fetching vendor hardware:', error);
        return { success: false, message: error.message, hardware: [] };
    }
};

export const autoSelectHardware = async (data) => {
    try {
        const response = await postMethod('/hardware/auto-select', data);
        return response;
    } catch (error) {
        console.error('Error auto-selecting hardware:', error);
        return { success: false, message: error.message };
    }
};

export const fetchProductType = async (id) => {
    try {
        const response = await getMethod(`/products/parent-category/${id}`);
        return response;
    } catch (error) {
        console.log("Error in fetching product parent Id: ", error);
        return { success: false, message: error.message };
    }
}